module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "ch-title"
  }, [_vm._v("Chapter 6")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Late in the afternoon of sunday, I took my spot in the last pew and waited for it all to end. The droning mass, and also maybe my hangover. My stomach felt like somebody had spent the morning walking all over it with stilts. My head felt somehow wet and leaky inside, as if my brain was a broken inkwell. I gave a passing thought to laying off booze, at least until takeoff from JFK.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Father Tim was far up in front, about a half dozen rows back from a plump, monotone monsignor who was providing half the crowd a fine nap with his homily. The bald crown of Father Tim’s silver-rimmed head was lit by a shaft of saintly light, softened and colored by its passage through a stained glass tableau of Christ’s crucifixion at Calvary.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I was thankful for Father Tim’s choice of this final mass. No way could I have met him earlier, not in my condition. I was even more thankful when the organist struck up a rousing recessional and the altar boys snuffed candles and trundled off with great bouquets of ferns and lilies and the late show was finally over. I myself am not the showy kind of Catholic; I say leave the big impressions to the Boss.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The sanctuary of Holy Cross Church quickly emptied of worshipers."), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v(" All but Father Tim, who remained to meet me; while waiting for me to appear, he lighted a votive taper to the statue of St. Jude, west of the pulpit among the stations of the cross. I walked up a side aisle toward him. He did not turn at my sound. Poor old guy, I thought, he must be going deaf. It occurred to me then that middle age was maybe not so bad, considering what comes next. I started to call his name. I stopped when I saw his eyes crinkle shut in solemnity, a rosary bead draped through his red-knuckled hands.")])]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("I stood still and crossed myself, then laced my fingers in front of me and bowed my head. And listened as Father Tim recited a novena.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“St. Jude, Apostle of Christ and helper in despairing cases, hear my prayers and petitions. In all my needs and desires, may I only seek what is pleasing to God, and what is best for my salvation.” Father Tim paused for a breath, then went on. “These, my petitions, I submit to thee, asking you to obtain them for me, if they are for the good of my soul. I am resigned to God’s Holy Will in all things, knowing that He will leave no sincere prayer unanswered … though it may be in a way unexpected by me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He opened his eyes and stared at the painted limestone statue, then up at the dust-speckled bands of sunlight fading rapidly in the stained glass window. From the corridors and cloakrooms surrounding the sanctuary there were familiar sounds: heavy doors moving on old hinges, light-switch buttons snapping off, oak floors creaking. Father Tim dropped his rosary into a side pocket of his black suitcoat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Father Tim?” I said, stepping toward him, expecting his customary grizzly-bear embrace.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hello, Neil.” Father Tim kept his arms stiffly at his sides, and looked at me blankly, as if it were hours rather than years since we had last seen one another.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("“You look good,” I said. The truth was, he looked twice as terrible as I felt. His face was puffy, and pale as lard. His once trim waist now bulged. He had a rash on his neck that I could see clear up over his Roman collar. His knees shook inside his baggy black trousers like two kids on a high school dance floor. “Listen to your lies, and here in the house of God on the Lord’s ")]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v(" own day!” Father Tim smiled, and forced a tinny laugh that made his nose hiss.")])]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("I closed the space between us and wrapped an arm around his shoulders, like I was his great-auntie and fearing that today was the last time I would touch him. I remembered his shoulders being so much bigger and harder once-upon-a-time. I smelled whiskey on him, and damn me but I fondly pictured a lowball of Johnnie Walker red over some shaved ice.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Thanks for coming back to the old neighborhood here to meet me, Father,” I said, vaguely wondering why he suggested such.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He gave my back some dutiful, fluttery pats, then broke free of my clutch. He pushed up one of his frayed coat sleeves and squinted at a gold Rolex underneath, his retirement gift from the Hell’s Kitchen CYO. “What’s this big ugly thing say?” he asked, raising his wrist for me to see the gaudy dial. “I forgot and left my cheaters up at home.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I thought, Where have I heard that before? I said, “Coming onto half past five.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What time’s your flight, Neil?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Eight … and how did you know about that?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Father Tim wiped his mouth, like maybe he wanted a nip so bad he thought he might taste whiskey on the back of his hand. “Well, look, I have recently been on the horn over there to Patrick Snoody, you know … about poor Liam and all,” he said. “Snoody, he mentioned how you’re soon on your way to Dún Laoghaire.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Did he now?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He did. He said you and some woman would soon be there. Who’s the woman?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Who’s this Snoody?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“A friend.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So he says. How come I never heard of him?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Your uncle has many friends on the other side. You can’t have heard of them all, see.” Father Tim squinted again at his Rolex, for what it was worth. He muttered, “There’s precious little time for a proper chat, Neil. Kindly don’t be sounding so much like the cop with me today.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Let’s go someplace for a jar,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Coffee’ll do.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("We left the church and walked slowly along Forty-second Street ")]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v(" over to Pete Pitsikoulis’s All-Night Eats & World’s Best Coffee, which is how the orange neon sign reads. We had to stop for a minute halfway up the block so that Father Tim could rest up his heart, as he put it. “Satan made off with my strength, leaving me cursed with this decrepitude,” he complained, leaning against a mailbox and wheezing like a freight train. “It seems only yesterday when I was chasing you little shits from the choir all’round the churchyard, eh?”")])]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("We made it to Pete’s, finally, and settled into a window booth. Wanda the waitress sponged the Formica tabletop, wiped it dry, then splattered it generously when she set down our ice water, two cups of coffee, a sugar bowl and creamer. “Enjoy it, you’s couple of big spenders,” she said, turning and then waddling off. I sopped up the spillage with paper napkins.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Father Tim spooned three mounds of sugar into his cup, and stirred in plenty of cream. I left mine black, which made Father Tim twist up his face with disgust. I asked, “What’s the matter?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re drinking Protestant coffee now? How can you stand it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I live, I let live.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, I see. How very liberal, Mr. I-think-I’ll-just-be-taking-along-some-woman-on-a-jet-airplane-trip-without-benefit-of-holy-matrimony.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The lady’s name is Ruby Flagg, we’re both over twenty-one, and you and I aren’t here to talk about that.” I took a long, slow sip of black coffee. Father Tim looked away, shuddering. I asked, “What’s with the praying to St. Jude?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m despairing of my health.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Maybe so, but it seemed like something more.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I want to be in the pink.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sure you do, but isn’t going to St. Jude a little drastic?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Father Tim looked very tired then; his eyes wandered, unfocused, unable to see beyond his screen of painful thought. He said, mechanically, “Well, there’s St. John for matters of general health …”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Whoever.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’d be whomever.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("“Skip the grammar lesson,” I said brusquely, in hopes of reducing Father Tim to the obvious. “Tell me what’s eating you.” ")]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Let’s remember it was you who called me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I wonder if you know why.” I reached into my jacket, pulled out Aidan Hockaday’s soldier portrait, and held it up between us. “See this?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Father Tim glanced at it, then dropped his head and sipped his creamed, sweetened coffee. He said, “I see that you’re showing me some picture. I don’t see what of.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You ought to, you’ve seen it a million times before. Think back to when I was still singing soprano for you, and you still had your health. And you’d come visit my mother and me—and your friend Liam, too, whenever he came to town. Especially then …”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I paused, realizing that I sounded more like a cop than a friend; realizing, too, how this did not bother me. I said to the priest’s bald, bowed head, “Think of the photograph that was always on top of the radio in our parlor. Remember, Father? And isn’t it that photograph that’s troubling you now?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Father Tim said nothing. For endless seconds he did not even look up. When he at last did, his face was as blank and closed as it had been in the church, after his novena to St. Jude.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I went to the movies yesterday, Neil,” he said, with a faraway and long ago sound to his words. “We’ve got a first-rate revival house up in Riverdale, you know. I went there. They were showing John Huston’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Beat the Devil,")]), _vm._v(" from 1954.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Some title for a priest to be seeing.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, but it’s a wonderful picture. There’s Bogart in it, and Gina Lollobrigida, and Robert Morley, and Peter Lorre. Truman Capote wrote the screenplay, not many people remember that. He wrote this great line about time that Lorre delivers. It goes, ‘Time—what is time? The Swiss manufacture it, the French hoard it, the Italians squander it … The Americans say it’s money.’” Father Tim sighed. “And would you like to know what I think time is, Neil?” I shrugged. At the moment, this did not seem important.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Time is a vandal,” said the troubled priest.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And now I gave him the blank look. And said, “There’s a poem on the back of the photograph, Father. Would you like for me to read it?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("“No!” Father Tim’s eyes welled with tears, and he placed a ")]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v(" hand over his heart. I was only adding to his troubles, whatever they were.")])]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m sorry, Father …”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But was I?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You see how come they went and retired old Tim Kelly,” he said, daubing his face with a napkin. He rose stiffly from his side of the booth. His black vest had bunched up over his soft belly, and he smoothed it down, then buttoned his coat over it, and struggled to put some dignity back into his voice. “I’ll now be returning to the home for us used-up priests. And if you don’t mind my thanks, Neil, the coffee’s on you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Wait.” I stood up, and put money on the table. “How are you getting back to Riverdale?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Subway, same as I come down. I’ve made a big success of the poverty vow.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We walked out to the street, Father Tim unsteady on my arm. Then in a surprising rush, he wished me well on the trip, and with Ruby, too, of whom he said, “It’s better a man’s with a woman, best he’s married to her, son.” But of his old friend Liam, he said nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I flagged a taxicab at Tenth Avenue and, over his mild protests, put Father Tim inside. I gave the driver thirty dollars, and he squawked about having to go all the way up to the Bronx with the likely prospect of dead-heading it back to Midtown. So I showed him my shield and my NYPD bracelets and reminded him about my very generous advance payment, as well as the public conveyance laws of the City of New York. He stopped squawking.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Father Tim rolled down a back window and told the driver, “Hold on a second, son.” Then he went to his pocket, the one with the rosary in it, and pulled up a medallion about the size of a silver dollar. He gave this to me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’ll find Ireland’s so full of unluck and storming rain that Jesus Christ Himself would need an umbrella,” he said. He touched the medallion in the palm of my hand. “Always keep this in your pocket while you’re on the other side, Neil. And for the sake of your life with Ruby Flagg, remember it’s there when you need it.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("He rolled up the window, staring at me with wet eyes. He said ")]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v(" something I could not hear, and crossed himself. Then he tapped the driver’s shoulder and the taxicab drove away.")])]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("I stood there, frozen in reflection of all that Davy Mogaill and Father Tim Kelly had told me that weekend, and all they had not. And the mood of my reflection was a betrayal, for I thought, Can you ever really know about your friends? ")]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-187a5431","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/10_Chapter06.vue
// module id = 96
// module chunks = 0